import PropTypes from 'prop-types';
import { createParagraphNode, htmlToSlate, isNotEmpty } from '../../Components/Fuse/FuseWysiwyg/utils';
import debug from '../../debug';
import BoolStore from '../helpers/BoolStore';
import RawValueStore from '../helpers/RawValueStore';
import EntityFormStore from '../helpers/EntityFormStore';
import ValueStore from '../helpers/ValueStore';

export default class CustomizeBlockPageBaseStore extends EntityFormStore {
    static _PropType = {
        ...EntityFormStore._PropType,
        enabled: BoolStore.PropTypes,
        content: RawValueStore.PropTypes,
        visible: BoolStore.PropTypes,
    };

    static PropType = PropTypes.shape(CustomizeBlockPageBaseStore._PropType);

    constructor(entityProps = {}, ...otherProps) {
        super(/** @class CustomizeBlockPageBaseStore */{
            enabled: new BoolStore(false),
            content: new RawValueStore([createParagraphNode()]),
            logo: new ValueStore(''), // delete after a couple of releases. for rollback compatibility to prevent NPE
            ...entityProps,
        }, {
            visible: new BoolStore(true),
        }, ...otherProps);

        this.content.setValidator(isNotEmpty);
    }

    _load = this.load;
    load = (...args) => this._load(...args).then((result) => {
        if (!result?.content && (result?.message || result?.headline || result?.logo)) {
            // combine headline and deserialized message into slate format in content value
            this.content.setValue([
                ...(result.logo ? [{
                    type: 'image',
                    src: result.logo,
                    children: [{ text: '' }],
                }, {
                    type: 'paragraph',
                    children: [{ text: '' }],
                }] : []),
                ...(result.headline ? [{
                    type: 'heading-one',
                    align: 'center',
                    children: [{ text: result.headline }],
                }, {
                    type: 'paragraph',
                    children: [{ text: '' }],
                }] : []),
                ...htmlToSlate(result.message || ''),
            ]);
        }

        return result;
    });

    isValid = () => {
        if (this.enabled.getValue() && !this.content.isValid()) {
            return false;
        }

        return true;
    };
}
